import React from "react";
import TimeSelector from "../../TimeSelector";
import moment from "moment";
import { nextAvailableTime } from "../../../helpers";
import { useModal } from "../../../assets/useModal";
import { DELIVERY } from "../../../constants";
import { useDispatch, useSelector } from "react-redux";
import { updateBasket } from "../../../actions/basket";
import { ImgIcon } from "../../../assets";
import { clock } from "../../../assets/icons";

export default function OrderTimeSelector() {

	const dispatch = useDispatch();
	const {
		vendor,
		basket
	} = useSelector(state => ({
		vendor: state.vendor,
		basket: state.basket
	}));

	const { openModal, setModal, closeModal } = useModal();

	const openingTimes = basket.type === DELIVERY ? vendor.deliveryTimes : vendor.collectionTimes;
	const minTime = basket.type === DELIVERY ? vendor.minDeliveryTime : vendor.minCollectionTime;

	function change() {
		setModal(
			<section key={basket.id} className="time-section">
				<h2>{`Select ${basket.type} time`}</h2>
				<TimeSelector
					value={basket.chosenTime}
					onChange={val => {
						dispatch(updateBasket({ chosenTime: val ? val.format() : val }));
						closeModal();
						setModal(null);
					}}
					openingTimes={openingTimes}
					minTime={minTime}
				/>
			</section>
		);
		openModal();
	}

	// Get the current time, or the next available one to act as ASAP.
	const currentTime = basket.chosenTime ?
		moment(basket.chosenTime) : nextAvailableTime(openingTimes, minTime);

	if (!currentTime) return null;
	
	// And flag up if it's today.
	const currentTimeIsToday = currentTime.isSame(moment(), "day");

	return <div className="orderTimeSelector flexy">

		<ImgIcon src={clock} size={35}/>

		<div className="currentTime featureFont">
			<span>
				{currentTimeIsToday ? "Today" : currentTime.format("DD MMM")} at
			</span>
			<br />
			<span>
				{currentTime.format("HH:mm")} {!basket.chosenTime && "(ASAP)"}
			</span>
		</div>

		<button
			className="change"
			onClick={change}
		>Change</button>

	</div >
}